import * as THREE from 'three'
import React, { useMemo } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation === "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption === "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture === "none" || params.wainscotTexture === "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const wallThickness = 0.005
    
    const wainscotTrimSideModelObj = useMemo(() => {
        /**********************cutting hole using CSG for side j-trim************************/
        const storageDelShape = new THREE.Shape();
            storageDelShape.moveTo(params.leanR_p_d / 2, 0);
            storageDelShape.lineTo(params.leanR_p_d / 2, params.leanR_p_h);
            storageDelShape.lineTo(params.leanR_p_d / 2 - parseInt(params.add_storage_right) - 0.12, params.leanR_p_h)
            storageDelShape.lineTo(params.leanR_p_d / 2 - parseInt(params.add_storage_right) - 0.12, 0);
            storageDelShape.closePath();

        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
        const meshStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageDelShape, extrudeSettings(0.4)))

        const meshJTrimCutModel_Temp = meshStorageDelModel.clone();
        meshJTrimCutModel_Temp.position.set(0, 0, -0.05)
        meshJTrimCutModel_Temp.updateMatrixWorld();

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.leanR_p_pos + params.rightLeanStoragePosition, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
        
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        /**********************cutting hole using CSG Side wainscot trim************************/
    
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage_right))), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set((params.leanR_p_d / 2), 3 , 0.1)
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/-2
        meshWainscotTrimModel_Temp.updateMatrixWorld()

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimSideModel = CSG.toMesh(WainscotTrimModel_CSG,new THREE.Matrix4())

        return CSGWainscotTrimSideModel.geometry;
    }, [params.leanR_p_pos, params.leanR_p_d, params.leanR_p_h, params.rightLeanStoragePosition, params.add_storage_right, params.add_storage_check_right, params.add_right_front_lean_porch, params.add_right_back_lean_porch, params.p_b_c_b_r, const_var.newDoorsArray])

    return (
        <group  position={[(params.p_w / 2 + params.leanR_p_w - 0.12 + 0.015 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
            {params.p_w_c_n == true && 
                <mesh name="wainscotTrim" geometry={wainscotTrimSideModelObj} >
                    <MaterialWainScotTrimNew   visibleSection={"rightlean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel